<div class="info-utilidad" [ngClass]="{ 'info-utilidad--ampliado': mostrarInfoSeniorYNormal }">
    
    <div *ngIf="mostrarInfoSeniorYNormal">
        <div class="row col-12">
            <h6><b>{{'SALUD.RECOMENDADOR.ALTERNATIVA_SENIOR_SIN_HOSPITALIZACION.ALTERNATIVA_PRODUCTO' | translate}}</b></h6>
        </div>
        <div class="row col-12">
            <div class="col-8">
                <h4>{{'SALUD.RECOMENDADOR.ALTERNATIVA_SENIOR_SIN_HOSPITALIZACION.SALUD_MEDICA' | translate}}</h4> 
            </div>
            <div class="col-4">
                <button ca-button (click)="onVerAlternativaSenior()">
                    {{ 'SALUD.RECOMENDADOR.ALTERNATIVA_SENIOR_SIN_HOSPITALIZACION.BOTON_CONSULTAR' | translate }}
                </button>
            </div>
        </div>
        <div class="row col-12">
            <p class="texto-con-saltos">
            {{ 'SALUD.RECOMENDADOR.ALTERNATIVA_SENIOR_SIN_HOSPITALIZACION.DESC_SALUD_MEDICA' | translate }}
            </p>        
        </div>
    </div>

    <h5>{{ 'SALUD.RECOMENDADOR.LABEL_OPCION.INFORMACION_UTILIDAD' | translate}}</h5>
    <ul>
        <ng-container *ngIf="!esDental; else dental">
            <li title="{{ 'SALUD.RECOMENDADOR.LABEL_OPCION.QUE_ES_COPAGO' | translate}}">{{
                'SALUD.RECOMENDADOR.LABEL_OPCION.COPAGO' | translate}}</li>
            <li *ngIf="!mostrarInfoSeniorYNormal">
                <a (click)="abrirModalInfoCampania()" href="javascript:void(0);">{{labelInfoCampania}}</a>
            </li>
            <li>
                <a [href]="urlCuadro">{{ 'SALUD.RECOMENDADOR.LABEL_OPCION.ACCESO_CUADRO_MEDICO' | translate }}</a>
            </li>
            <li *ngIf="!mostrarInfoSeniorYNormal">
                <a href="javascript:void(0);" (click)="onVerTodosProductos()">
                    {{ 'SALUD.RECOMENDADOR.LABEL_OPCION.VER_PRODUCTOS' | translate }}
                </a>
            </li>
        </ng-container>

        <ng-template #dental>
            <li>
                <a [href]="urlCuadro">{{ 'SALUD.RECOMENDADOR.LABEL_OPCION.ACCESO_CUADRO_CLINICAS_DENTALES' | translate }}</a>
            </li>
        </ng-template>
    </ul>
</div>